import { createReducer } from '@reduxjs/toolkit'
import { SET_PHARMACIES } from './actions'
import { SUCCESS, REQUEST, FAILURE } from '../../constants/statuses'

const initialState = {
  pharmacies: [],
  pagination: {
    page: 1,
    perPage: 10,
    amount: 2
  },
  isLoading: false,
  isError: false
}

export const pharmaciesReducer = createReducer(initialState, {
  [SET_PHARMACIES[SUCCESS]]: (state, action) => {
    state.pharmacies = action.payload.data.pharmacies
    state.pagination.amount = action.payload.data.amount
    state.pagination.page = action.payload.paging.page
    if (action.payload.paging.count !== 9999) {
      state.pagination.perPage = action.payload.paging.count
    }
    state.isLoading = false
  },

  [SET_PHARMACIES[REQUEST]]: (state, action) => {
    state.isError = false
    state.isLoading = true
  },

  [SET_PHARMACIES[FAILURE]]: (state, action) => {
    state.isLoading = false
    state.isError = true
  }
})
